import {useMutation, useQueryClient} from "@tanstack/react-query";
import {AxiosError} from "axios";
import jobRepository from "../../repository/WorkflowJobRepository";


const useInterruptJob = (jobId: string) => {
    const queryClient = useQueryClient();

    return useMutation<undefined, AxiosError>({
        mutationKey: ["jobs", jobId, 'command'],
        mutationFn: async () => {
            const {data} = await jobRepository.interrupt(jobId);
            return data.result;
        },
        onSuccess: async () => {
            await Promise.all([
                queryClient.invalidateQueries(["workflow", "job", jobId]),
                queryClient.invalidateQueries(["workflow", "jobs"]),
            ]);
        },
    })
};

export default useInterruptJob;